<a [routerLink]="['/home']" [fragment]="homePageSections[activeSectionIndex]">
    <button class="nextsection" (click)="onClickNextSection()">
        <div class="icon">
            <img src="../../../assets/images/home-page/nextSection.svg" alt="">
        </div> Next section
    </button>
</a>
<!-- <div class="upcomingContest" [class.OpenSlider]="openBar">
    <div class="iconButton">
        <button (click)="toggleField()">
            <img src="../../../assets/images/home-page/sliderArow.svg" alt="">
        </button>
    </div>  
    <div class="mainBody">
        <h3>Upcoming contests</h3>
        <div class="contest-list" *ngIf="contestList">
            <div *ngFor="let contest of contestList.slice(0, 2); trackBy: trackByFn" class="listMain">
                <div class="contestCard" [ngClass]="(contest?.isDouble) ? 'double' : ''">
                    <div class="contestHeader">
                        <div class="contest-user-details d-flex justify-content-center align-items-center">
                            <div class="user d-flex flex-column">
                                <div class="contest-playername-details d-flex align-items-center">
                                    <div class="image mr-2">
                                        <img [src]="contest.player1Image" alt="" class="single-div" loading="lazy">
                                    </div>
                                    <div class="username">
                                        <h4>{{contest.player1Name.split('/')[0]}}</h4>
                                    </div>
                                </div>
                                <div class="contest-playername-details d-flex align-items-center">
                                    <div class="image mr-2" *ngIf="contest?.isDouble">
                                        <img [src]="contest.player1Image" alt="" class="single-div" loading="lazy">
                                    </div>
                                    <div class="username" *ngIf="contest?.isDouble">
                                        <h4>{{contest.player1Name.split('/')[1]}}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="vs">
                                V/S
                            </div>
                            <div class="user d-flex flex-column right-users">
                                <div class="contest-playername-details d-flex align-items-center">
                                    <div class="username text-right mr-2">
                                        <h4> {{contest.player2Name.split('/')[0]}}</h4>
                                    </div>
                                    <div class="image ">
                                        <img [src]="contest.player2Image" alt="" class="single-div" loading="lazy">
                                    </div>
                                </div>
                                <div class="contest-playername-details d-flex align-items-center">
                                    <div class="username text-right mr-2" *ngIf="contest?.isDouble">
                                        <h4>{{contest.player2Name.split('/')[1]}}</h4>
                                    </div>
                                    <div class="image " *ngIf="contest?.isDouble">
                                        <img [src]="contest.player2Image" alt="" class="single-div" loading="lazy">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="contestBody">
                        <div class="bodyheading">
                            <h5>{{contest.tournamentName}}</h5>
                            <a href="{{contest.shareurl}}" target="_blank">
                                <button>
                                    <span> <img src="assets/images/home-page/share.svg" alt=""> </span> SHARE
                                </button>
                            </a>
                        </div>
                        <div class="iconList">
                            <ul>
                                <li>
                                    <div class="icon-main">
                                        <div class="icon">
                                            <img src="assets/images/home-page/location.svg" alt="">
                                        </div>
                                        <div class="label">
                                            <h6>{{contest.displaytournamentName}}</h6>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="divLine"></div>
                                </li>
                                <li>
                                    <div class="icon-main">
                                        <div class="icon">
                                            <img src="assets/images/home-page/calendar.svg" alt="">
                                        </div>
                                        <div class="label">
                                            <h6>{{contest.matchDate|date:'d MMM'}}</h6>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="divLine"></div>
                                </li>
                                <li>
                                    <div class="icon-main">
                                        <div class="icon">
                                            <img src="assets/images/home-page/time.svg" alt="">
                                        </div>
                                        <div class="label">
                                            <h6>{{contest.matchDate|date:'h:mm a'}}</h6>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="divLine"></div>
                                </li>
                                <li>
                                    <div class="icon-main">
                                        <div class="icon">
                                            <img src="assets/images/home-page/users.svg" alt="">
                                        </div>
                                        <div class="label">
                                            <h6>{{contest.totalEntries}}</h6>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="ContestFooter">
                            <div class="left">
                                <h6>Prize Pool</h6>
                                <button
                                    *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0 && !contest?.giveAway"><span>{{contest.updatedPoolCoins}}
                                        TPL Coins</span></button>
                                <button
                                    *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0 && !contest?.giveAway"><span><i
                                            class='bx bx-rupee'></i>{{contest.updatedPoolCash}}</span></button>
                                <button class="rewardsBtn" *ngIf="contest?.giveAway">
                                    <span class="rewardsText"><span>{{ contest?.giveAway }}</span></span>
                                    <i>
                                        <img src="../../../assets/images/home-page/information-circle.svg" alt="">
                                    </i>
                                </button>
                            </div>
                            <div class="right">
                                <h6 *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                    Entry Fee: {{contest.entryFee}} TPL Coins</h6>
                                <h6 *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                    Entry Fee: <i
                                        *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"
                                        class='bx bx-rupee'></i> {{contest.entryFee}}
                                </h6>
                                <div class="joinBtn">
                                    <div *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == undefined"
                                        class=" joinBtn">
                                        <button (click)="onClickJoin(contest)" [disabled]="isAcademy"
                                            class="contest-btn" [ngClass]="isAcademy ? 'disableAcademyJoin' : ''"> JOIN
                                            NOW
                                        </button>
                                    </div>
                                    <div *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == true"
                                        class=" joinBtn">
                                        <button (click)="onClickLive(contest)" class="contest-btn">
                                            Leaderboard <i class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <div *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == false"
                                        class=" joinBtn">
                                        <button (click)="onClickRejoin(contest)" class="contest-btn">
                                            Resume <i class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == true"
                                        class=" joinBtn">
                                        <button (click)="onClickLive(contest)" class="contest-btn"> Live <i
                                                class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'finished'" class=" joinBtn">
                                        <button routerLink="/contest" class="contest-btn">
                                            {{contest.prizeDistributionDone==true ? 'Close' :'In Review'}}<i
                                                class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == undefined"
                                        class=" joinBtn">
                                        <button class="contest-btn"> Live <i class='bx bx-right-arrow-alt'></i></button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == false"
                                        class=" joinBtn">
                                        <button class="contest-btn"> Live <i class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == true"
                                        class=" joinBtn">
                                        <button (click)="onClickLive(contest)" class="contest-btn"> Close <i
                                                class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == undefined"
                                        class=" joinBtn">
                                        <button class="contest-btn"> Close </button>
                                    </div>
                                    <div *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == false"
                                        class=" joinBtn">
                                        <button class="contest-btn"> Close <i class='bx bx-right-arrow-alt'></i>
                                        </button>
                                    </div>
                                    <button
                                        *ngIf="contest.tournamentMatchStatus === 'suspended' || contest.tournamentMatchStatus === 'interrupted' || contest.tournamentMatchStatus === 'canceled'"
                                        class="contest-btn"> Match Suspended
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer-contest">
                        <button type="button" (click)="showPrizePoolNewstructure(contest)">View pool Structure</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section id="hero" class="d-flex align-items-center justify-content-center main-banner-slider">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 p-p-0 desktopSlider">
                <swiper class="swiper-container clients-slider zoom-effect-container desktop-slider" fxFlex="auto"
                    [config]="Top_config" [disabled]="disabled" (indexChange)="onIndexChange($event)"
                    (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container">
                        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
                            <a [href]="banner?.bannerImageLink" target="_blank"
                                *ngIf="banner.bannerImageLinkType === 'External'">
                                <div class="headings image-card">
                                    <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                        [lazyLoad]="banner.banner_image_src" class="product-image" alt="banner" />
                                    <div class="slider-inner-div">
                                        <div class="container">
                                            <div class="main-heading-banner">
                                                <div class="sldier-bottom-section"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <a [href]="banner?.bannerImageLink" *ngIf="banner.bannerImageLinkType === 'Internal'">
                                <div class="headings image-card">
                                    <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                        [lazyLoad]="banner.banner_image_src" class="product-image" alt="banner" />
                                    <div class="slider-inner-div">
                                        <div class="container">
                                            <div class="main-heading-banner">
                                                <div class="sldier-bottom-section"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="headings image-card" *ngIf="banner.bannerImageLinkType === null">
                                <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                    [lazyLoad]="banner.banner_image_src" class="product-image" alt="banner" />
                                <div class="slider-inner-div">
                                    <div class="container">
                                        <div class="main-heading-banner">
                                            <div class="sldier-bottom-section"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
            <div class="col-md-12 p-p-0 mobileSlider">
                <swiper class="swiper-container clients-slider zoom-effect-container desktop-slider" fxFlex="auto"
                    [config]="Top_config" [disabled]="disabled" (indexChange)="onIndexChange($event)"
                    (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div *ngFor="let banner of mobileBannerImageList " class="swiper-slide zoom-effect-container">
                        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
                            <a [href]="banner?.mobileBannerImageLink" target="_blank"
                                *ngIf="banner.mobileBannerImageLinkType === 'External'">
                                <div class="headings image-card">
                                    <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                        [lazyLoad]="banner.banner_image_src" class="product-image" alt="banner" />
                                    <div class="slider-inner-div">
                                        <div class="container">
                                            <div class="main-heading-banner">
                                                <div class="sldier-bottom-section"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <a [href]="banner?.mobileBannerImageLink"
                                *ngIf="banner.mobileBannerImageLinkType === 'Internal'">
                                <div class="headings image-card">
                                    <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                        [lazyLoad]="banner.banner_image_src" class="product-image" alt="banner" />
                                    <div class="slider-inner-div">
                                        <div class="container">
                                            <div class="main-heading-banner">
                                                <div class="sldier-bottom-section"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="headings image-card" *ngIf="banner.mobileBannerImageLinkType === null">
                                <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                    [lazyLoad]="banner.banner_image_src" class="product-image" alt="banner" />
                                <div class="slider-inner-div">
                                    <div class="container">
                                        <div class="main-heading-banner">
                                            <div class="sldier-bottom-section"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
        </div>
    </div>
</section>
<section class="cards-section" id="cardsSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12 main-list">
                <div class="cardList" routerLink="/tournaments" (click)="onNavigateToTournaments()">
                    <h4>Tournaments</h4>
                    <p>Compete in Tournaments</p>
                    <button>
                        REGISTER
                    </button>
                    <img src="../../../assets/images/home-page/1.webp" alt="" class="bg-image-right">
                </div>
                <div class="cardList" (click)="onDownloadClick('bottom')">
                    <h4>Book A Court</h4>
                    <p>Find the nearest court</p>
                    <button>
                        BOOK NOW
                    </button>
                    <img src="../../../assets/images/home-page/cc1.webp" alt="" class="bg-image-right">
                </div>
                <div class="cardList" routerLink="/academies">
                    <h4>Academies</h4>
                    <p>Find the best Academies</p>
                    <button>
                        View
                    </button>
                    <img src="../../../assets/images/home-page/4.webp" alt="" class="bg-image-right">
                </div>
                <div class="cardList" routerLink="/find-partner">
                    <h4>Find a Partner</h4>
                    <p>Play with anyone</p>
                    <button>
                        find
                    </button>
                    <img src="../../../assets/images/home-page/3.webp" alt="" class="bg-image-right">
                </div>
            </div>
            <!-- <div class="lineHeight">
                <hr>
            </div> -->
        </div>
    </div>
</section>
<!-- <section class="mobileversionContest">
    <a routerLink="/contest">
        <div class="sectionHeading">
            <div class="left-heading">
                <h2>Contests</h2>
                <p>Participate in wide array of contests</p>
            </div>
            <div class="icon">
            <img src="../../../assets/images/home-page/contestUiball.png" alt="">
            </div>
        </div>
    </a>      
</section> -->
<!-- <section class="contest-section pt-0" id="contestSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Contests</h2>
                        <p>Participate in wide array of contests</p>
                    </div>
                    <div class="right-heading">
                        <button routerLink="/contest">VIEW ALL</button>
                    </div>
                </div>
            </div>
            <div class="contest-list">
                <swiper class="swiper-container clients-slider" fxFlex="auto" *ngIf="contestListCnt > 0"
                    [config]="todayContest">
                    <div *ngFor="let contest of contestList; trackBy: trackByFn" class="swiper-slide">
                        <div class="contestCard" [ngClass]="(contest?.isDouble) ? 'double' : ''">
                            <div class="contestHeader">
                                <div class="contest-user-details d-flex justify-content-center align-items-center">
                                    <div class="user d-flex flex-column">
                                        <div class="contest-playername-details d-flex align-items-center">
                                            <div class="image mr-2">
                                                <img [src]="contest.player1Image" alt="" class="single-div"
                                                    loading="lazy">
                                            </div>
                                            <div class="username">
                                                <h4>{{contest.player1Name.split('/')[0]}}</h4>
                                            </div>
                                        </div>
                                        <div class="contest-playername-details d-flex align-items-center">
                                            <div class="image mr-2" *ngIf="contest?.isDouble">
                                                <img [src]="contest.player1Image" alt="" class="single-div"
                                                    loading="lazy">
                                            </div>
                                            <div class="username" *ngIf="contest?.isDouble">
                                                <h4>{{contest.player1Name.split('/')[1]}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vs">
                                        V/S
                                    </div>
                                    <div class="user d-flex flex-column right-users ">
                                        <div class="contest-playername-details d-flex align-items-center">
                                            <div class="username text-right mr-2">
                                                <h4> {{contest.player2Name.split('/')[0]}}</h4>
                                            </div>
                                            <div class="image ">
                                                <img [src]="contest.player2Image" alt="" class="single-div"
                                                    loading="lazy">
                                            </div>
                                        </div>
                                        <div class="contest-playername-details d-flex align-items-center">
                                            <div class="username text-right mr-2" *ngIf="contest?.isDouble">
                                                <h4>{{contest.player2Name.split('/')[1]}}</h4>
                                            </div>
                                            <div class="image " *ngIf="contest?.isDouble">
                                                <img [src]="contest.player2Image" alt="" class="single-div"
                                                    loading="lazy">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="contestBody">
                                <div class="bodyheading">
                                    <h5>{{contest.tournamentName}}</h5>

                                    <a href="{{contest.shareurl}}" target="_blank">
                                        <button>
                                            <span> <img src="assets/images/home-page/share.svg" alt=""> </span> SHARE
                                        </button>
                                    </a>
                                </div>
                                <div class="iconList">
                                    <ul>
                                        <li>
                                            <div class="icon-main">
                                                <div class="icon">
                                                    <img src="assets/images/home-page/location.svg" alt="">
                                                </div>
                                                <div class="label">
                                                    <h6>{{contest.displaytournamentName}}</h6>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="divLine"></div>
                                        </li>
                                        <li>
                                            <div class="icon-main">
                                                <div class="icon">
                                                    <img src="assets/images/home-page/calendar.svg" alt="">
                                                </div>
                                                <div class="label">
                                                    <h6>{{contest.matchDate|date:'d MMM'}}</h6>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="divLine"></div>
                                        </li>
                                        <li>
                                            <div class="icon-main">
                                                <div class="icon">
                                                    <img src="assets/images/home-page/time.svg" alt="">
                                                </div>
                                                <div class="label">
                                                    <h6>{{contest.matchDate|date:'h:mm a'}}</h6>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="divLine"></div>
                                        </li>
                                        <li>
                                            <div class="icon-main">
                                                <div class="icon">
                                                    <img src="assets/images/home-page/users.svg" alt="">
                                                </div>
                                                <div class="label">
                                                    <h6>{{contest.totalEntries}}</h6>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="ContestFooter">
                                    <div class="left">
                                        <h6>Prize Pool</h6>
                                        <button
                                            *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0 && !contest?.giveAway"><span>{{contest.updatedPoolCoins}}
                                                TPL Coins</span></button>
                                        <button
                                            *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0 && !contest?.giveAway"><span><i
                                                    class='bx bx-rupee'></i>{{contest.updatedPoolCash}}</span></button>
                                        <button class="rewardsBtn" *ngIf="contest?.giveAway">
                                            <span class="rewardsText"><span>{{contest?.giveAway}}</span></span>
                                            <i>
                                                <img src="../../../assets/images/home-page/information-circle.svg"
                                                    alt="">
                                            </i>
                                        </button>
                                    </div>
                                    <div class="right">
                                        <h6 *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                            Entry Fee: {{contest.entryFee}} TPL Coins</h6>
                                        <h6 *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                            Entry Fee: <i
                                                *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"
                                                class='bx bx-rupee'></i> {{contest.entryFee}}
                                        </h6>
                                        <div class="joinBtn">
                                            <div *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == undefined"
                                                class=" joinBtn">
                                                <button (click)="onClickJoin(contest)" [disabled]="isAcademy"
                                                    class="contest-btn"
                                                    [ngClass]="isAcademy ? 'disableAcademyJoin' : ''"> JOIN NOW
                                                </button>
                                            </div>
                                            <div *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == true"
                                                class=" joinBtn">
                                                <button (click)="onClickLive(contest)" class="contest-btn">
                                                    Leaderboard <i class='bx bx-right-arrow-alt'></i>
                                                </button>
                                            </div>
                                            <div *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == false"
                                                class=" joinBtn">
                                                <button (click)="onClickRejoin(contest)" class="contest-btn">
                                                    Resume <i class='bx bx-right-arrow-alt'></i>
                                                </button>
                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == true"
                                                class=" joinBtn">
                                                <button (click)="onClickLive(contest)" class="contest-btn"> Live <i
                                                        class='bx bx-right-arrow-alt'></i>
                                                </button>
                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'finished'" class=" joinBtn">
                                                <button routerLink="/contest" class="contest-btn">
                                                    {{contest.prizeDistributionDone==true ? 'Close' :'In Review'}}<i
                                                        class='bx bx-right-arrow-alt'></i>
                                                </button>
                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == undefined"
                                                class=" joinBtn">
                                                <button class="contest-btn"> Live <i
                                                        class='bx bx-right-arrow-alt'></i></button>
                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == false"
                                                class=" joinBtn">
                                                <button class="contest-btn"> Live <i class='bx bx-right-arrow-alt'></i>
                                                </button>
                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == true"
                                                class=" joinBtn">
                                                <button (click)="onClickLive(contest)" class="contest-btn"> Close <i
                                                        class='bx bx-right-arrow-alt'></i>
                                                </button>

                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == undefined"
                                                class=" joinBtn">
                                                <button class="contest-btn"> Close </button>
                                            </div>
                                            <div *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == false"
                                                class=" joinBtn">
                                                <button class="contest-btn"> Close <i class='bx bx-right-arrow-alt'></i>
                                                </button>
                                            </div>
                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'suspended' || contest.tournamentMatchStatus === 'interrupted' || contest.tournamentMatchStatus === 'canceled'"
                                                class="contest-btn"> Match Suspended
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-contest">
                                <button type="button" (click)="showPrizePoolNewstructure(contest)">View pool
                                    Structure</button>
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
        </div>
    </div>
</section> -->
<section class="feature-section" id="featuredThisWeekSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Featured This Week</h2>
                        <p>Celebrate with the winners</p>
                    </div>
                    <div class="right-heading">
                        <button (click)="onDownloadClick('bottom')">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <div class="home-skeleton-row"
                        *ngIf="(sectionLoading['featuredThisWeekSection'] || !loadedSections['featuredThisWeekSection']) && !featureList?.length">
                        <div class="home-skeleton-card feature-skeleton" *ngFor="let item of skeletonSlides"></div>
                    </div>
                    <swiper class="swiper-container  " fxFlex="auto" [config]="featureListSlider"
                        *ngIf="featureList?.length">
                        <div *ngFor="let feature of featureList" class="swiper-slide  ">
                            <a [href]="feature?.link" target="_blank">
                                <div class="main-slider">
                                    <div class="overly-color"></div>
                                    <img [src]="feature?.photo" alt="">
                                    <div class="feature-div-details">
                                        <div class="footerDiv">
                                            <h6 *ngIf="feature?.date">
                                                {{feature?.date | ordinalDate}}
                                            </h6>
                                            <h5>
                                                {{feature?.title}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="tournaments-section" id="tournamentSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Upcoming Tournaments</h2>
                        <p>Check out all the upcoming tournaments</p>
                    </div>
                    <div class="right-heading">
                        <button routerLink="/tournaments">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <div class="home-skeleton-row"
                        *ngIf="(sectionLoading['tournamentSection'] || !loadedSections['tournamentSection']) && !tournamentList?.length">
                        <div class="home-skeleton-card tournament-skeleton" *ngFor="let item of skeletonSlides">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <swiper class="swiper-container  " fxFlex="auto" [config]="tournamentListSlider"
                        *ngIf="tournamentList?.length">
                        <div *ngFor="let tournament  of tournamentList" class="swiper-slide  ">
                            <div class="main-slider" [id]="'heading' + tournament.id">
                                <div class="tournament-div-details">
                                    <div class="tournament-header">
                                        <div class="tournament-logo">
                                            <img [src]="(tournament.academyPic) ? tournament.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                                alt="">
                                        </div>
                                    </div>
                                    <div class="tournamentName">
                                        <h4>{{tournament.name}}</h4>
                                    </div>
                                    <div class="touranmentLocation">
                                        <div class="location">
                                            <div class="icon">
                                                <img src="../../../assets/images/home-page/locationfilled.svg" alt="">
                                            </div>
                                            <div class="city">
                                                <span>{{tournament.cityname}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tournament-table">
                                        <table>
                                            <tr>
                                                <td class="left-table">
                                                    <div class="lable">
                                                        <div class="left-icon">
                                                            <img src="../../../assets/images/home-page/calendar1.svg"
                                                                alt="">
                                                        </div>
                                                        <div class="title">
                                                            Date
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="right-table">
                                                    <span>
                                                        {{ tournament?.startdate | date:'dd/MM/YY' }} - {{
                                                        tournament?.enddate | date:'dd/MM/YY' }}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="left-table">
                                                    <div class="lable">
                                                        <div class="left-icon">
                                                            <img src="../../../assets/images/home-page/level.svg"
                                                                alt="">
                                                        </div>
                                                        <div class="title">
                                                            Level
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="right-table">
                                                    <span class="level"
                                                        *ngIf="pointsDataNameCheckFunc(tournament) && tournament.pointsDataName.length > 0">
                                                        {{tournament.pointsDataName}}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="left-table">
                                                    <div class="lable">
                                                        <div class="left-icon">
                                                            <img src="../../../assets/images/home-page/category.svg"
                                                                alt="">
                                                        </div>
                                                        <div class="title">
                                                            Categories
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="right-table"
                                                    [ngClass]="(tournament.isViewMore) ? 'openText' : ''">
                                                    <span class="CategoriesListdiv"
                                                        *ngIf="matchDataNameCheckFunc(tournament) && tournament?.matchDataName !== null">
                                                        {{(!tournament.isViewMore) ? tournament.matchDataName[0] :
                                                        tournament.matchDataName }}
                                                    </span>
                                                    <button class="viewMoreBtn"
                                                        *ngIf="matchDataNameCheckFunc(tournament) && tournament?.matchDataName !== null && tournament?.matchDataName.length > 1"
                                                        (click)="viewMoreCategoriesToggleOption(tournament)">
                                                        {{ (!tournament.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="left-table">
                                                    <div class="lable">
                                                        <div class="left-icon">
                                                            <img src="../../../assets/images/home-page/draw.svg" alt="">
                                                        </div>
                                                        <div class="title">
                                                            Draw Type
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="right-table">
                                                    <span>
                                                        {{tournament?.drawTypeNames}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="tournament-fees">
                                        <div class="fees"
                                            *ngIf="tournament?.minimumEntryFee !== tournament?.maximumEntryFee; else f2">
                                            ENTRY FEES: ₹{{tournament?.minimumEntryFee}} -
                                            ₹{{tournament?.maximumEntryFee}}
                                        </div>
                                        <ng-template #f2>
                                            <div class="fees">
                                                ENTRY FEES: ₹{{tournament?.maximumEntryFee}}
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="tournament-footer">
                                        <button class="fbutton" (click)="onclickTournamentdetails(tournament?.id)">
                                            <span>
                                                <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                            </span>
                                            FACTSHEET
                                        </button>
                                        <button class="rbutton" (click)="onclickTournamentdetails(tournament?.id)">
                                            <span>
                                                <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                            </span>
                                            REGISTER
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="offers-section" id="estoreSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>E-store</h2>
                        <p>Best offers on equipments, tickets and bookings.</p>
                    </div>
                    <div class="right-heading">
                        <button (click)="onDownloadClick('bottom')">VIEW ALL</button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 grid-offers">
                <div class="banner-01" (click)="onDownloadClick('bottom')">
                    <img src="../../../assets/images/home-page/05-offer-011.webp" alt="">
                </div>
                <div class="banner-02" (click)="onDownloadClick('bottom')">
                    <img src="../../../assets/images/home-page/05-offer-s021.webp" alt="">
                </div>
                <div class="banner-03" (click)="onDownloadClick('bottom')">
                    <img src="../../../assets/images/home-page/05-offer-031.webp" alt="">
                </div>
            </div>
        </div>
    </div>
</section>
<div class="bg-image">
    <section class="news-section" id="newsSection">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="sectionHeading">
                        <div class="left-heading">
                            <h2>News</h2>
                            <p>All the activity in the world of tennis.</p>
                        </div>
                        <div class="right-heading">
                            <button routerLink="/media">VIEW ALL</button>
                        </div>
                    </div>
                    <div class="slider-main">
                        <div class="home-skeleton-row"
                            *ngIf="(sectionLoading['newsSection'] || !loadedSections['newsSection']) && !tplNews?.length">
                            <div class="home-skeleton-card news-skeleton" *ngFor="let item of skeletonSlides">
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                        <swiper class="swiper-container  " fxFlex="auto" [config]="newsSlider" *ngIf="tplNews?.length">
                            <div *ngFor="let news of tplNews" class="swiper-slide  ">
                                <div class="main-slider">
                                    <div class="news-image">
                                        <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                            [lazyLoad]="news.newsImage" alt="">
                                    </div>
                                    <div class="main-title">
                                        <h4> {{news.title}} </h4>
                                    </div>
                                    <div class="paragraph">
                                        <p> {{news.description}}</p>
                                    </div>
                                    <a href="{{news.url}}" target="_blank" class="bttuon">
                                        <img src="../../../assets/images/home-page/Upright.svg" alt="">
                                    </a>
                                    <!-- <div class="bttuon" routerLink="{{news.url}}"> -->
                                    <!-- <img src="../../../assets/images/home-page/Upright.svg" alt=""> -->
                                    <!-- </div> -->
                                    <!-- <div class="bttuon" routerLink="{{news.url}}">
                                        <img src="../../../assets/images/home-page/Upright.svg" alt="">
                                    </div> -->
                                </div>
                            </div>
                        </swiper>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="tpl-works-section" id="tplWorksSection">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="sectionHeading">
                        <div class="left-heading">
                            <h2>How tpl works</h2>
                        </div>
                    </div>
                    <div class="videos-slider">
                        <div class="home-skeleton-row"
                            *ngIf="(sectionLoading['tplWorksSection'] || !loadedSections['tplWorksSection']) && !faqSection?.length">
                            <div class="home-skeleton-card video-skeleton" *ngFor="let item of skeletonSlides">
                                <span></span>
                            </div>
                        </div>
                        <swiper class="swiper-container clients-slider" fxFlex="auto" [config]="faqSlider"
                            *ngIf="faqSection?.length">
                            <div *ngFor="let homeVideos of faqSection; trackBy: trackByFn" class="swiper-slide">
                                <div class="main-slider"
                                    (click)="showVideoDialog(homeVideos.youtubechannelurl, homeVideos.title)">
                                    <div class="imageBanner">
                                        <img [src]="homeVideos.thumbNailImage[0]?.image_src" alt="" class="faq-banner"
                                            loading="lazy">
                                    </div>
                                    <div class="videofooter">
                                        <div class="title">
                                            {{homeVideos.title}}
                                        </div>
                                        <button class="paly-button">
                                            <img src="../../../assets/images/home-page/play.svg" alt="">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="artical-section" id="featuredArticlesSection">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="sectionHeading">
                        <div class="left-heading">
                            <h2>Featured Articles</h2>
                            <p>Articles on all things tennis.</p>
                        </div>
                        <div class="right-heading">
                            <button routerLink="/blog">VIEW ALL</button>
                        </div>
                    </div>
                    <div class="slider-main">
                        <div class="home-skeleton-row"
                            *ngIf="(sectionLoading['featuredArticlesSection'] || !loadedSections['featuredArticlesSection']) && !blogs?.length">
                            <div class="home-skeleton-card news-skeleton" *ngFor="let item of skeletonSlides">
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                        <swiper class="swiper-container  " fxFlex="auto" [config]="newsSlider" *ngIf="blogs?.length">
                            <div *ngFor="let blog of blogs" class="swiper-slide  ">
                                <div class="main-slider">
                                    <div class="news-image">
                                        <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                            [lazyLoad]="blog?.blogImage[0]?.image_src" alt="">
                                    </div>
                                    <div class="main-text-div-button">
                                        <div class="text-div">
                                            <div class="main-title">
                                                <h4> {{blog.title}}</h4>
                                            </div>
                                            <div class="paragraph">
                                                <p> {{blog.shortdescription}}</p>
                                            </div>
                                        </div>
                                        <div class="buttonDiv">
                                            <button routerLink="/blog/{{blog.id}}">
                                                <img src="../../../assets/images/home-page/articalarrow.svg " alt="">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<section class="reward-section" id="rewardSection" >
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Redeem Rewards</h2>
                        <p>Rack up rewards on and off the Court</p>
                    </div>
                    <div class="right-heading" *ngIf="rewardList?.length">
                        <button (click)="onDownloadClick('bottom')">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <div class="home-skeleton-row"
                        *ngIf="(sectionLoading['rewardSection'] || !loadedSections['rewardSection']) && !rewardList?.length">
                        <div class="home-skeleton-card reward-skeleton" *ngFor="let item of skeletonSlides">
                            <span></span>
                        </div>
                    </div>
                    <div class="no-rewards" role="status" aria-live="polite"
                        *ngIf="loadedSections['rewardSection'] && !sectionLoading['rewardSection'] && !rewardList?.length">
                        <div class="no-rewards__visual" aria-hidden="true">
                            <span class="no-rewards__spark no-rewards__spark--one"></span>
                            <span class="no-rewards__spark no-rewards__spark--two"></span>
                            <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="24" y="39" width="48" height="40" rx="7" fill="white"
                                    stroke="#157042" stroke-width="3" />
                                <path d="M48 40V79" stroke="#157042" stroke-width="3" />
                                <rect x="20" y="31" width="56" height="16" rx="6" fill="#DBE210"
                                    stroke="#157042" stroke-width="3" />
                                <path d="M48 31C40 31 33 28 33 22.5C33 18.4 36.2 15 40.3 15C46.5 15 48 24.8 48 31Z"
                                    fill="white" stroke="#157042" stroke-width="3" stroke-linejoin="round" />
                                <path d="M48 31C56 31 63 28 63 22.5C63 18.4 59.8 15 55.7 15C49.5 15 48 24.8 48 31Z"
                                    fill="white" stroke="#157042" stroke-width="3" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="no-rewards__content">
                            <span class="no-rewards__eyebrow">Coming soon</span>
                            <h3>Fresh rewards are on the way</h3>
                            <p>Keep collecting TPL Coins &mdash; new surprises will land here soon.</p>
                        </div>
                    </div>
                    <swiper class="swiper-container  " fxFlex="auto" [config]="rewardSlider" *ngIf="rewardList?.length">
                        <div *ngFor="let reward of rewardList" class="swiper-slide  ">
                            <div class="main-slider">
                                <div class="rewards-image">
                                    <img [src]="reward.image" alt="">
                                </div>
                                <div class="main-text-div-button">
                                    <div class="text-div">
                                        <div class="main-title">
                                            <!-- (mouseenter)="rewardOverlay.show($event)"
                                                (mouseleave)="rewardOverlay.hide()" -->
                                            <h4 (click)="rewardOverlay.toggle($event)"
                                                (mouseenter)="rewardOverlay.show($event)"
                                                (mouseleave)="rewardOverlay.hide()">
                                                {{ reward.name }}
                                            </h4>
                                            <p-overlayPanel #rewardOverlay appendTo="body" styleClass="headingPopup">
                                                <ng-template pTemplate>
                                                    <div class="popupTitle">
                                                        {{ reward.name }}
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
                                        </div>
                                        <div class="coins-details">
                                            <p> <span class="icon"> <img src="assets/images/home-page/coin.svg" alt="">
                                                </span> {{reward.price | number:'1.0-0'}} TPL Coin</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper>
                    <div class="swiper-pagination" *ngIf="rewardList?.length"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="coins-section" id="getTplCoinsSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>get tpl coins</h2>
                        <p>Rack up rewards on and off the Court.</p>
                    </div>
                    <div class="right-heading">
                        <button (click)="onDownloadClick('bottom')">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <div class="home-skeleton-row"
                        *ngIf="(sectionLoading['getTplCoinsSection'] || !loadedSections['getTplCoinsSection']) && !coinsRewardList?.length">
                        <div class="home-skeleton-card coins-skeleton" *ngFor="let item of skeletonSlides"></div>
                    </div>
                    <swiper class="swiper-container  " fxFlex="auto" [config]="coinsRewardSlider"
                        *ngIf="coinsRewardList?.length">
                        <div *ngFor="let reward of coinsRewardList" class="swiper-slide  ">
                            <div class="main-slider">
                                <div class="rewards-image">
                                    <img [src]="reward.image" alt="">
                                </div>
                            </div>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-dialog [(visible)]="FAQVideoPopup" [modal]="true" [breakpoints]="{'960px': '500px', '768px': 'calc(100vw - 50px)'}"
    [style]="{width: '500px'}" id="FAQVideoPopup">
    <div class="title-div">
        <h5>
            {{videoTitle}}
        </h5>
    </div>
    <div class="videos-Url">
        <iframe width="420" height="315" *ngIf="videoLink" [src]="videoLink" frameborder="0"
            allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
</p-dialog>
<p-dialog header="winnings" [(visible)]="pricePoolStructurePopup" [modal]="true" [style]="{ width: '30%' }"
    [draggable]="false" [resizable]="false" id="poolStructurePopup2"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <div class="col-md-12 p-p-0">
        <div class="tableTitle">
            <h4>contest prize pool structure</h4>
        </div>
        <div class="tablediv">
            <table class="table ">
                <thead>
                    <tr>
                        <th scope="col" class="entries-position">Position</th>
                        <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7
                            Entries</th>
                        <th scope="col" class="entries-position" *ngIf="eightToTen">8 to 10 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="elevenToThirteen">11 to 13 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="fourteenToEighteen">14 to 18 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 Entries</th>
                        <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ Entries</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngIf="twoToFour || fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">1st</th>
                        <td class="table-data" *ngIf="twoToFour">100%</td>
                        <td class="table-data" *ngIf="fiveToSeven">65%</td>
                        <td class="table-data" *ngIf="eightToTen">50%</td>
                        <td class="table-data" *ngIf="elevenToThirteen">40%</td>
                        <td class="table-data" *ngIf="fourteenToEighteen">40%</td>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">33%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">29%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">28%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                    </tr>
                    <tr
                        *ngIf="fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">2nd</th>
                        <td class="table-data" *ngIf="fiveToSeven">35%</td>
                        <td class="table-data" *ngIf="eightToTen">30%</td>
                        <td class="table-data" *ngIf="elevenToThirteen">30%</td>
                        <td class="table-data" *ngIf="fourteenToEighteen">23%</td>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">20%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">18%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">16%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                    </tr>
                    <tr
                        *ngIf="eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">3rd</th>
                        <td class="table-data" *ngIf="eightToTen">20%</td>
                        <td class="table-data" *ngIf="elevenToThirteen">20%</td>
                        <td class="table-data" *ngIf="fourteenToEighteen">16%</td>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">15%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">14%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                    </tr>
                    <tr
                        *ngIf="elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">4th</th>
                        <td class="table-data" *ngIf="elevenToThirteen">10%</td>
                        <td class="table-data" *ngIf="fourteenToEighteen">12%</td>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">11%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">11%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                    </tr>
                    <tr
                        *ngIf="fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">5th</th>
                        <td class="table-data" *ngIf="fourteenToEighteen">9%</td>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">8%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">9%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">9%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                    </tr>
                    <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">6th</th>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">7%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">8%</td>

                    </tr>
                    <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">7th</th>
                        <td class="table-data" *ngIf="nineteenToTwentySeven">6%</td>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                    </tr>
                    <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">8th</th>
                        <td class="table-data" *ngIf="twentyEightToThirtySix">5%</td>
                        <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                    </tr>
                    <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                        <th scope="row" class="entries-position">9th</th>
                        <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                        <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                    </tr>
                    <tr *ngIf="fiftyOnePlus">
                        <th scope="row" class="entries-position">10th</th>
                        <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</p-dialog>
<p-dialog id="terms" [closable]="true" [(visible)]="showContestDetailSection" [modal]="true" [style]="{width: '500px'}"
    (onHide)="onCloseShowContestDetailSection()" header="Points System"
    [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 60px)'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <div class="modal-content team qize-section question-list quize-description">
        <div class="note-top">
            <p class="text">SELECT THE BEST COMBINATION TO MAXIMIZE YOUR POINTS</p>
        </div>
        <div class="modal-body modal-Detals">
            <div class="col-md-12 quiz-main-body">
                <div class="qizeheader">
                    <div class="mobile-version">
                    </div>
                    <div class="left-title w-auto"> </div>
                </div>
                <div class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-12 p-p-0">
                                <div class="point-list">
                                    <ul>
                                        <li>
                                            ⁠Choose 1 option from one player
                                        </li>
                                        <li>
                                            ⁠Choose 2 options for the other player
                                        </li>
                                    </ul>
                                    <div class="note2">
                                        <p class="text"> ⁠Total points will be calculated based on the 3 options
                                            selected</p>
                                    </div>
                                </div>
                                <div class="point-table">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col" colspan="2">points system</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Point Won</th>
                                                <td class="table-data">1 point</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Game Won</th>
                                                <td class="table-data">6 points</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">⁠1 Set Won</th>
                                                <td class="table-data">50 points</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Service Point won</th>
                                                <td class="table-data">1.5 points</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">⁠1 Ace</th>
                                                <td class="table-data">15 points</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Break Point won</th>
                                                <td class="table-data">20 points</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12  acept-div0main">
                                    <div class="form-check p-0 d-flex align-items-start mb-2"
                                        [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
                                        <p-checkbox binary="true" [(ngModel)]="isTAndCSelected"
                                            (onChange)="onTermsAndConditionsSelect($event)"></p-checkbox>
                                        <label class="form-check-label" for="defaultCheck1">
                                            I accept the <a href="/termsandcondition#TPLcontest">Terms and
                                                Conditions</a> as well as the <a (click)="showOldPoolstructure()">Prize
                                                Pool Structure .</a>
                                        </label>
                                    </div>
                                    <div class="error-msg" *ngIf="showTermsAndConditionError">
                                        <span>Please Accept Terms and Conditions.</span>
                                    </div>
                                </div>
                            </div> <!-- End of col-sm-12 -->
                        </div> <!-- End of row -->
                    </div> <!-- ENd of container fluid -->
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="footer-buttons-section">
            <button class="btn btn-success w-auto m-auto" pButton (click)="onClickSubmit()"
                [disabled]="!isTAndCSelected">Submit</button>
        </div>
    </ng-template>
</p-dialog>
<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>
        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>
        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>
